import { expensifyUnlinkError } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

const unlinkExpensifyError = () => addMessage(expensifyUnlinkError);
export default unlinkExpensifyError;
